import React, { useEffect, useState } from 'react';
import axios from 'axios';

import 'moment/locale/ko';

export default function AnalysisSw() {
  return <>AnalysisSw</>;
}
